/*
 * bind：發生時機點為指令第一次綁定到元素上時，因此只會使用一次。
 * inserted：綁定元素插入父節點時使用。
 * update：綁定元素在模版更新時使用。
 * componentUpdated：綁定元素在元件更新時使用。
 * unbind：解除指令與元素的綁定。
 */

/* name：自定義指令名，不含前綴「v-」，如下例的「say」。
 * value：指令的綁定值，如下例的「{"name":"Peter","prompt":"Hello World"}」。
 * oldValue：綁定值的前一個值，儘在 update 或 componentUpdated 時可用。
 * expression：綁定值的字串，如上例的「dollar」、下例的「{"name":"Peter","prompt":"Hello World"}」。
 * arg：傳給自定義指令的參數，如上例的「currency」、下例的「hello」。
 * modifiers：修飾符，如下例的「a」、「b」、「c」。如果不知道修飾符是什麼，可參考事件修飾符 (Event Modifiers)。
 */
// https://cythilya.github.io/2017/05/05/vue-custom-directive/
import Vue from 'vue';
import Clipboard from 'clipboard'
import { messageError, messageSuccess } from "@utils/message";

Vue.directive('clipboard', {
  bind: function(el, binding) {
    new Clipboard(el, {
      text: function() {
        return binding.value
      },
    })
      .on('success', () => {
        messageSuccess({
          title: '複製成功',
          content: binding.value
        });
      })
      .on('error', () => {
        messageError('複製失敗');
      });
  }
});

Vue.directive('focus-scroll', {
  bind: function(el, binding) {

    /*
     FIXME: 暫時移除
     const $input = el.querySelector("input, textarea");

     $input.addEventListener('focus', (e) => {
     Vue.prototype.$scrollToElement({
     $el: $input,
     position: 'center',
     speed: 1
     });
     }); */
  }
});
